import React from 'react';

import { InitialConfiguration } from '../interfaces';

/**
 * Default data of widget before it sets info from parent
 */
const defaultConfig: InitialConfiguration = {
    id: '1',
    brand: 'vw',
    version: '',
    model: '',
    year: '',
    isPFA: true,
    externalId: '',
};
/**
 * Global context of the provided brand for general use
 */
export const ProvidersContext = React.createContext(defaultConfig);
